<template>
  <div class="external-div">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'PopupFrame',
  componentName: "PopupFrame",
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/common/popupFrame.vue